import React from "react";
import axios from "axios";
import history from "../../auth/history";
import { connect } from "react-redux";
import BillPaymentModal from "./BillPaymentModal";
import Header from "../headerComponent/Header";
import LeftMenu from "../leftSideComponent/LeftSide";
import BillPaymentHistory from "./BillPaymentHistory";
import HeadSearch from "../headSearch/HeadSearch";
import BillPaymentFilter from "./BillPaymentFilter";
import { Link } from "react-router-dom";
import moment from "moment";
import { CSVLink } from "react-csv";
import tokenErrorHandler from "../tokenErrorHandler";
import { findAllInRenderedTree } from "react-dom/test-utils";
const httpClient = axios.create();

class BillPayment extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			phoneNo: this.props.phone,
			types: [
				{ value: "ELECTRICITY", label: "Electricity" },
				// { value: "Mobile", label: "Mobile" },
				{ value: "GAS", label: "Gas" },
				// { value: "Landline", label: "Landline" },
				// { value: "Broadband", label: "Broadband" },
				{ value: "WATER", label: "Water" },
				// { value: "Insurance", label: "Insurance" }

			],
			statusValues: [
				{ value: "Select", label: "Select" },
				{ value: "Success", label: "Success" },
				{ value: "Failed", label: "Failed" },
				{ value: "Pending", label: "Pending" },
				{ value: "Processing", label: "Processing" }
			],

			batchList: [],
			dwnLoadDtaList: [],
			batchLoading: 'loading',
			status: '',
			type: '',
			startDate: '',
			startTime: '',
			endDate: '',
			endTime: '',
			orderId: '',
			searchOn: false
		}
	}

	loadHistory = () => {
		this.setState({
			batchLoading: 'loading',
			dwnLoadDtaList: [],
			searchOn:false
		})
		var url = '/api/v1/billpay/corp/consumer/batch-list/';
		const headers = {
			'Authorization': 'Bearer ' + this.props.token,
			'client-id': this.props.agentInfo,
			'role': this.props.clientRole
		}
		httpClient.get(url + this.props.agentInfo,
			{ headers }
		).then((response) => {

			this.setState({
				searchOn:true
			})
			var batchList = [];
			var dwnLoadDtaList = [];
			if (response.data != undefined &&
				response.data != null &&
				response.data.length > 0) {
				response.data.reverse().map(res => {


					if (res.consumerList != undefined &&
						res.consumerList != null &&
						res.consumerList.length > 0
					) {
						res.consumerList.map(
							consumer => {

								if (this.state.startTime != '' &&
									this.state.endTime != '') {
									var val = moment(consumer.updatedOn).format('YYYY-MM-DD');
									var date = new Date(val);
									var updateOnTime = date.getTime();
									// alert('updateOnTime'+updateOnTime)
									// alert('endTime',this.state.endTime)
									if (updateOnTime <= this.state.endTime &&
										updateOnTime >= this.state.startTime) {

										var optional1 = '';
										var operator_id = '';

										if (consumer.lastPaidBill != undefined &&
											consumer.lastPaidBill != null) {
											optional1 = consumer.lastPaidBill.optional;
											if (optional1 != undefined &&
												optional1 != null) {
												operator_id = optional1.OPERATOR_ID;
												if (operator_id == undefined ||
													operator_id == null ||
													operator_id == '') {
													operator_id = optional1.operator_id;
												}
											}
										}

										var data = {
											ID: consumer.id,
											RequesterId: consumer.requesterId,
											AgentId: consumer.agentId,
											OrderId: consumer.orderId,
											Optional: Object.entries(consumer.optional).map(([key, value]) => `${key}=${value}`).join(';'),
											Operator_id: (operator_id != undefined && operator_id != null && operator_id != '') ? operator_id : 'NA',
											CreateOrderDate: consumer.createOrderDate,
											ConsumerName: consumer.consumerName,
											Branch: consumer.branchNameOrId,
											BillerCategory: consumer.billerCategory,
											BillerName: consumer.billerName,
											DueDate: consumer.dueDate,
											LAST_BILL_FETCH: (consumer.lastBillFetch != undefined && consumer.lastBillFetch != null) ? Object.entries(consumer.lastBillFetch).map(([key, value]) => `${key}=${value}`).join(';') : "NA",
											Operator: consumer.operator,
											MobileNo: consumer.mobileNo,
											Last_Status: consumer.lastKnownStatus,
											BatchId: consumer.batchId,
											TxnDate: moment(consumer.createdOn).format('DD-MM-YYYY HH:mm:ss'),
											Amount: consumer.currentBillPayAmount,
											BillPayDetails: (optional1 != undefined && optional1 != null) ? Object.entries(optional1).map(([key, value]) => `${key}=${value}`).join(';') : "NA"
										}
										var consumer = {
											batchId: res.id,
											data: consumer
										}
										batchList.push(consumer);



										dwnLoadDtaList.push(data)
									}
								} else {
									var optional1 = '';
									var operator_id = '';

									if (consumer.lastPaidBill != undefined &&
										consumer.lastPaidBill != null) {
										optional1 = consumer.lastPaidBill.optional;
										if (optional1 != undefined &&
											optional1 != null) {
											operator_id = optional1.OPERATOR_ID;
											if (operator_id == undefined ||
												operator_id == null ||
												operator_id == '') {
												operator_id = optional1.operator_id;
											}
										}
									}

									var data = {
										ID: consumer.id,
										RequesterId: consumer.requesterId,
										AgentId: consumer.agentId,
										OrderId: consumer.orderId,
										Optional: Object.entries(consumer.optional).map(([key, value]) => `${key}=${value}`).join(';'),
										Operator_id: (operator_id != undefined && operator_id != null && operator_id != '') ? operator_id : 'NA',
										CreateOrderDate: consumer.createOrderDate,
										ConsumerName: consumer.consumerName,
										Branch: consumer.branchNameOrId,
										BillerCategory: consumer.billerCategory,
										BillerName: consumer.billerName,
										DueDate: consumer.dueDate,
										LAST_BILL_FETCH: (consumer.lastBillFetch != undefined && consumer.lastBillFetch != null) ? Object.entries(consumer.lastBillFetch).map(([key, value]) => `${key}=${value}`).join(';') : "NA",
										Operator: consumer.operator,
										MobileNo: consumer.mobileNo,
										Last_Status: consumer.lastKnownStatus,
										BatchId: consumer.batchId,
										TxnDate: moment(consumer.createdOn).format('DD-MM-YYYY HH:mm:ss'),
										Amount: consumer.currentBillPayAmount,
										BillPayDetails: (optional1 != undefined && optional1 != null) ? Object.entries(optional1).map(([key, value]) => `${key}=${value}`).join(';') : "NA"
									}
									var consumer = {
										batchId: res.id,
										data: consumer
									}
									batchList.push(consumer);



									dwnLoadDtaList.push(data)
								}

							})
					}

				})
			}



			var batchList1 = [];
			var batchList2 = [];
			var dwnLoadDtaList1 = [];
			var dwnLoadDtaList2 = [];

			if (this.state.status != '') {

				batchList.map(batch => {
					if (batch.data.lastKnownStatus == this.state.status) {
						batchList1.push(batch)
						var consumer = batch.data;

						var optional1 = '';
						var operator_id = '';

						if (consumer.lastPaidBill != undefined &&
							consumer.lastPaidBill != null) {
							optional1 = consumer.lastPaidBill.optional;
							if (optional1 != undefined &&
								optional1 != null) {
								operator_id = optional1.OPERATOR_ID;
								if (operator_id == undefined ||
									operator_id == null ||
									operator_id == '') {
									operator_id = optional1.operator_id;
								}
							}
						}

						var data = {
							ID: consumer.id,
							RequesterId: consumer.requesterId,
							AgentId: consumer.agentId,
							OrderId: consumer.orderId,
							Optional: Object.entries(consumer.optional).map(([key, value]) => `${key}=${value}`).join(';'),
							Operator_id: (operator_id != undefined && operator_id != null && operator_id != '') ? operator_id : 'NA',
							CreateOrderDate: consumer.createOrderDate,
							ConsumerName: consumer.consumerName,
							Branch: consumer.branchNameOrId,
							BillerCategory: consumer.billerCategory,
							BillerName: consumer.billerName,
							DueDate: consumer.dueDate,
							LAST_BILL_FETCH: (consumer.lastBillFetch != undefined && consumer.lastBillFetch != null) ? Object.entries(consumer.lastBillFetch).map(([key, value]) => `${key}=${value}`).join(';') : "NA",
							Operator: consumer.operator,
							MobileNo: consumer.mobileNo,
							Last_Status: consumer.lastKnownStatus,
							BatchId: consumer.batchId,
							TxnDate: moment(consumer.createdOn).format('DD-MM-YYYY HH:mm:ss'),
							Amount: consumer.currentBillPayAmount,
							BillPayDetails: (optional1 != undefined && optional1 != null) ? Object.entries(optional1).map(([key, value]) => `${key}=${value}`).join(';') : "NA"
						}
						dwnLoadDtaList1.push(data)
					}
				})

			} else {
				batchList1 = batchList;
				dwnLoadDtaList1 = dwnLoadDtaList;
			}
			if (this.state.type != '') {
				batchList1.map(batch => {
					if (batch.data.billerCategory == this.state.type) {
						batchList2.push(batch)
						var consumer = batch.data;
						var optional1 = '';
						var operator_id = '';

						if (consumer.lastPaidBill != undefined &&
							consumer.lastPaidBill != null) {
							optional1 = consumer.lastPaidBill.optional;
							if (optional1 != undefined &&
								optional1 != null) {
								operator_id = optional1.OPERATOR_ID;
								if (operator_id == undefined ||
									operator_id == null ||
									operator_id == '') {
									operator_id = optional1.operator_id;
								}
							}
						}

						var data = {
							ID: consumer.id,
							RequesterId: consumer.requesterId,
							AgentId: consumer.agentId,
							OrderId: consumer.orderId,
							Optional: Object.entries(consumer.optional).map(([key, value]) => `${key}=${value}`).join(';'),
							Operator_id: (operator_id != undefined && operator_id != null && operator_id != '') ? operator_id : 'NA',
							CreateOrderDate: consumer.createOrderDate,
							ConsumerName: consumer.consumerName,
							Branch: consumer.branchNameOrId,
							BillerCategory: consumer.billerCategory,
							BillerName: consumer.billerName,
							DueDate: consumer.dueDate,
							LAST_BILL_FETCH: (consumer.lastBillFetch != undefined && consumer.lastBillFetch != null) ? Object.entries(consumer.lastBillFetch).map(([key, value]) => `${key}=${value}`).join(';') : "NA",
							Operator: consumer.operator,
							MobileNo: consumer.mobileNo,
							Last_Status: consumer.lastKnownStatus,
							BatchId: consumer.batchId,
							TxnDate: moment(consumer.createdOn).format('DD-MM-YYYY HH:mm:ss'),
							Amount: consumer.currentBillPayAmount,
							BillPayDetails: (optional1 != undefined && optional1 != null) ? Object.entries(optional1).map(([key, value]) => `${key}=${value}`).join(';') : "NA"
						}
						dwnLoadDtaList1.push(data)
					}
				})
			} else {
				batchList2 = batchList1;
				dwnLoadDtaList2 = dwnLoadDtaList;
			}



			this.setState({
				batchList: batchList2,
				dwnLoadDtaList: dwnLoadDtaList2,
				batchLoading: 'completed'
			})
		}).catch(error => {
			this.setState({
				batchLoading: 'completed',
				searchOn:true
			})
			if (error.message.includes("401")) {
				tokenErrorHandler.tokenErrorHandle(error.message, this.props.callBackUrl)
			}
		});
	}
	componentDidMount() {
		this.loadHistory();
	}
	componentWillUnmount() {
	}


	selectFromDate = (event) => {
		this.setState({
			startDate: event.target.value
		})
	}
	selectToDate = (event) => {
		this.setState({
			endDate: event.target.value
		})
	}

	typeSelect = (event) => {
		this.setState({
			type: event.target.value
		})
	}


	statusSelect = (event) => {
		var status = '';
	
		if (event.target.value == 'Success') {
			status = 'BILL_PAY_SUCCESS';
		} else if (event.target.value == 'Failed') {
			status = 'BILL_PAY_FAILED';
		} else if (event.target.value == 'Pending') {
			status = 'BILL_PAY_PENDING';
		} else if (event.target.value == 'Processing') {
			status = 'BILL_PAY_PROCESSING'
		}
		this.setState({
			status: status
		})
	}

	submit = (event) => {
		event.preventDefault();

		this.setState({
			startTime: '',
			endTime: ''
		})
		var allow = true;


		if (this.state.startDate == '' && this.state.endDate == '') {
			allow = true;
		}
		if (this.state.startDate != '' && this.state.endDate != '') {
			allow = true;
			var date1 = new Date(this.state.startDate);
			var date2 = new Date(this.state.endDate);

			this.setState({
				startTime: date1.getTime(),
				endTime: date2.getTime()
			})
		}
		if (this.state.startDate != '' && this.state.endDate == '') {
			allow = false;
			alert('end date is not selected');
		}
		if (this.state.startDate == '' && this.state.endDate != '') {
			allow = false;
			alert('start date is not selected');
		}

		if (allow == true) {
			this.loadHistory();
		} else {

		}

	}


	reset = () => {
		this.setState({
			startDate: '',
			startTime: '',
			endDate: '',
			endTime: '',
			type: '',
			status: '',
			orderId: '',
			startIndex: 0,
			searchOn:false
		})

		setTimeout(() => {
			this.loadHistory();
		}, 200);
	}
	clearAll = () => {
		this.setState({
			startDate: '',
			startTime: '',
			endDate: '',
			endTime: '',
			type: '',
			status: '',
			orderId: ''
		})

		setTimeout(() => {
			this.loadHistory();
		}, 200);
	}

	enterOrderId = (event) => {
		event.preventDefault();
		this.setState({
			orderId: event.target.value.trim()
		})

	}
	searchOrder = (event) => {
		var batchList = [];
		this.setState({
			batchLoading: 'loading',
			searchOn: true,
			dwnLoadDtaList: []
		})

		var dwnLoadDtaList = [];
		var optional1 = '';
		this.state.batchList.map(consumer => {
			if (JSON.stringify(consumer.data).includes(this.state.orderId)) {
				batchList.push(consumer);

				var optional1 = '';
				var operator_id = '';

				if (consumer.data.lastPaidBill != undefined &&
					consumer.data.lastPaidBill != null) {
					optional1 = consumer.data.lastPaidBill.optional;
					if (optional1 != undefined &&
						optional1 != null) {
						operator_id = optional1.OPERATOR_ID;
						if (operator_id == undefined ||
							operator_id == null ||
							operator_id == '') {
							operator_id = optional1.operator_id;
						}
					}
				}
				var data = {
					ID: consumer.id,
							RequesterId: consumer.data.requesterId,
							AgentId: consumer.data.agentId,
							OrderId: consumer.data.orderId,
							Optional: Object.entries(consumer.data.optional).map(([key, value]) => `${key}=${value}`).join(';'),
							Operator_id: (operator_id != undefined && operator_id != null && operator_id != '') ? operator_id : 'NA',
							CreateOrderDate: consumer.data.createOrderDate,
							ConsumerName: consumer.data.consumerName,
							Branch: consumer.data.branchNameOrId,
							BillerCategory: consumer.data.billerCategory,
							BillerName: consumer.data.billerName,
							DueDate: consumer.data.dueDate,
							LAST_BILL_FETCH: (consumer.data.lastBillFetch != undefined && consumer.lastBillFetch != null) ? Object.entries(consumer.lastBillFetch).map(([key, value]) => `${key}=${value}`).join(';') : "NA",
							Operator: consumer.data.operator,
							MobileNo: consumer.data.mobileNo,
							Last_Status: consumer.data.lastKnownStatus,
							BatchId: consumer.data.batchId,
							TxnDate: moment(consumer.data.createdOn).format('DD-MM-YYYY HH:mm:ss'),
							Amount: consumer.data.currentBillPayAmount,
							BillPayDetails: (optional1 != undefined && optional1 != null) ? Object.entries(optional1).map(([key, value]) => `${key}=${value}`).join(';') : "NA"
				}
				dwnLoadDtaList.push(data);

			} else {
				// alert('not-found');
			}
		})

		setTimeout(() => {
			this.setState({
				batchList: batchList,
				batchLoading: 'completed',
				dwnLoadDtaList: dwnLoadDtaList,
				searchOn:false
			})
		}, 200);

	}


	render() {

		return (
			<div>
				<div class="main">
					<LeftMenu />

					<div class="right-side">
						<div class="container-fluid">

							<Header />
							<div class="row">
								<div class="col-12">
									<div class="card">
										<div class="dashhead">
											<h3>Bill Payment History</h3>
											{this.state.batchLoading != 'loading' &&
												this.state.dwnLoadDtaList != undefined &&
												this.state.dwnLoadDtaList.length > 0 &&
												<CSVLink
													class="lbbtn"
													data={this.state.dwnLoadDtaList}
													asyncOnClick={true}
													// onClick={this.resetExportDate}
													filename={this.props.agentInfo + "_txn_history" + ".csv"}
												>
													Download History
												</CSVLink>
											}

											{this.state.batchLoading != 'loading' &&
												this.state.batchList != undefined &&
												this.state.batchList.length > 0 &&
												<Link to='/batch-list'>
													<button type="button" class="lbbtn"
													>Batch </button>
												</Link>

											}
											<div class="hisfltr">
												<div class="dropdown filbox">
													<button type="button" class="dropdown-toggle fltrbtn" data-bs-auto-close="outside" id="fltrid" data-bs-toggle="dropdown" aria-expanded="false" aria-haspopup="true"></button>

													<div class="dropdown-menu dropdown-menu-end" aria-labelledby="fltrid">
														<form>
															<div class="filters">
																<label for="select-state">Type:</label>

																<select data-placeholder="..." 
																	class="chosen-select" tabindex="8"
																	onChange={this.typeSelect}>
																	{this.state.types.map(type => (
																		<option value={type.value}
																		>{type.value}</option>
																	))}
																</select>

															</div>

															<div class="filters">
																<label for="select-state">Status:</label>

																<select data-placeholder="..." 
																	class="chosen-select" tabindex="8"
																	onChange={this.statusSelect}>
																	{this.state.statusValues.map(status => (
																		<option value={status.value}
																		>{status.value}</option>
																	))}
																</select>

															</div>

															<div class="filters">
																<label for="select-state">Due Date From:</label>
																<input type="date" name="" placeholder="DD/MM/YYYY"
																	onChange={this.selectFromDate} />
															</div>
															<div class="filters">
																<label for="select-state">Due Date To:</label>
																<input type="date" name="" placeholder="DD/MM/YYYY"
																	onChange={this.selectToDate} />
															</div>
															<div class="filters">
																<button type="button" class="clear" id="btnSubmit"
																	onClick={this.submit}>Submit</button>
																<button type="reset" class="clear" id="btnClear"
																	onClick={this.reset}>Clear</button>
															</div>
														</form>
													</div>
												</div>
											</div>

											<div class="headsrch">
												<div class="input-group">
													<input type="text" class="form-control" placeholder="Search..."
														aria-describedby="srchbtn" onChange={this.enterOrderId}
														value={this.state.orderId}
														disabled={this.state.searchOn==false?true:false} />
													<button class="btn" type="button" id="srchbtn" 
													onClick={this.searchOrder}
													disabled={this.state.searchOn==false?true:false}>search</button>
													<button type="btn" class="lbbtn" id="btnClear"
														onClick={this.reset}>Clear</button>
												</div>
											</div>


										</div>
										{this.state.batchLoading == 'loading' &&
											<div>Loading....
												<div class="spinner-grow spinner-grow-sm"></div>
											</div>}
										{this.state.batchLoading != 'loading' &&
											this.state.batchList != undefined &&
											this.state.batchList.length > 0 &&
											<BillPaymentHistory
												batchList={this.state.batchList} />
										}
										{this.state.batchLoading != 'loading' &&
											this.state.batchList != undefined &&
											this.state.batchList.length == 0 &&
											<div>No Batch Found!</div>
										}

									</div>
								</div>
							</div>
						</div>
					</div>

				</div>
				<div class="footer-txt">Copyright &copy; 2021 All rights reserved.
					<br />Powered by FinXpay Solutions Pvt. Ltd.
				</div>

			</div >

		);
	}
}

const mapStateToProps = (
	{ errorMessageReduce: { errorMessage },
		miscReduce: { phone, agentInfo, token, clientRole } }
) => ({
	errorMessage, phone, agentInfo, token, clientRole
});

export default connect(mapStateToProps, null)(BillPayment);
